/* eslint-disable ts/no-unsafe-argument */
import "./main.css";

import { VueQueryPlugin } from "@tanstack/vue-query";
import { createHead } from "@unhead/vue/client";
import { createPinia } from "pinia";
import sentryConfig from "virtual:sentryclirc";
import { createApp } from "vue";

import { i18n } from "@/i18n";
import { isRunningLocally } from "@/utils";

import { queryClient } from "./queryClient";
import { router } from "./router";
import { loadSentry } from "./sentry";

import App from "./App.vue";

// Initial mount of the app should wait for translations to be fetched & loaded.

const pinia = createPinia();
const app = createApp(App);

const head = createHead();

// Load Sentry if it is configured and app isn't running locally.
if (!isRunningLocally() && sentryConfig.fileExists) {
  loadSentry(app, router);
}

app.use(i18n);
app.use(pinia);
app.use(router);
app.use(VueQueryPlugin, { queryClient, enableDevtoolsV6Plugin: true });
app.use(head);
app.mount("#app");
